<!--
 * @Author: jzh
 * @Date: 2020-12-07 14:35:12
 * @LastEditors: DQL
 * @LastEditTime: 2022-01-28 15:43:32
 * @Description: 切换组织
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-50"
    title="切换组织"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="118px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col c-form__part-title"
            :span="24"
          >
            用户基本信息
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="用户编码"
              prop="userCode"
            >
              {{ fd.userCode }}
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="用户名称"
              prop="userName"
            >
              {{ fd.userName }}
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="所属组织"
              prop="deptCode"
            >
              <hm-tree-select
                ref="dept"
                v-model="fd.deptCode"
                class="c-tree-select-wrap"
                instance-id="cTreeSelect"
                placeholder="请选择所属组织"
                :append-to-body="true"
                :clearable="false"
                :options="deptList"
                :normalizer="normalizer"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSave()"
      >
        保存
      </el-button>
      <el-button
        @click="closeDialog()"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { userService, allDeptTree } from './user.service';

export default {
  name: 'ChangeDeptDialog', // 单身份切换组织
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示
      loading: false, // 页面loading状态

      /* 表单参数 Start */
      fd: {
        /* 表单参数必须写入，无默认值为null，避免页面加载时由于使用了对象里不存在的参数而出现报错信息 */
        userName: null, // 用户名称
        userCode: null, // 用户编码
        deptCode: null // 身份所属组织/部门
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {
        userCode: [
          this.$validUtils.required('用户编码'),
          this.$HMValidator.maxLength('用户编码', 36)
        ],
        userName: [
          this.$validUtils.required('用户名称'),
          this.$HMValidator.maxLength('用户名称', 75)
        ],
        deptCode: [
          this.$validUtils.required('组织')
        ]
      },
      /* 表单校验规则 End */
      deptList: [] // 组织列表
    };
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * @description: 转换下拉树节点字段
     * @param {*}
     * @return {*}
     */
    normalizer (node) {
      if (node.childNodes == null || node.childNodes.length === 0) {
        return {
          id: node.nodeCode,
          label: node.nodeName
        };
      }
      return {
        id: node.nodeCode,
        label: node.nodeName,
        children: node.childNodes
      };
    },
    /**
     * @description: 获取组织机构树
     * @param {*}
     * @return {*}
     */
    getAllDeptTree () {
      allDeptTree()
        .then(rsp => {
          this.deptList = rsp.data;
        })
        .finally(() => {
          this.$nextTick(() => {
            this.loading = false;
          });
        });
    },
    /**
     * @description: 保存
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.$refs.fd.validate((valid) => {
        if (valid) {
          this.loading = true;
          userService.changeDept(this.fd.userCode, this.fd.deptCode)
            .then(rsp => {
              this.$alert('保存成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              this.$emit('closeDialog', '');
              this.$emit('callback');
            })
            .catch(err => {
              console.error('切换保存出错！', err);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    /**
     * @description: 页面初始化
     * @param {*}
     * @return {*}
     */
    init () {
      this.loading = true;
      // 传入参数
      this.fd.deptCode = this.dlParams.deptCode;
      this.fd.userCode = this.dlParams.userCode;
      this.fd.userName = this.dlParams.userName;
      if (this.fd.deptCode === undefined || this.fd.deptCode === null || this.fd.deptCode === '') {
        this.$alert('组织编码不存在！', '提示', {
          confirmButtonText: '确定',
          type: 'success',
          callback: action => {
            this.$emit('closeDialog', '');
          }
        });
      }
      if (this.fd.userCode === undefined || this.fd.userCode === null || this.fd.userCode === '') {
        this.$alert('用户编码不存在！', '提示', {
          confirmButtonText: '确定',
          type: 'success',
          callback: action => {
            this.$emit('closeDialog', '');
          }
        });
      }
      // 初始化组织机构树
      this.getAllDeptTree();
    }
  },
  created () {
    this.init();
  }
};
</script>
